<template>
  <div :class="$options.name">
    <v-card>
      <v-toolbar color="blue darken-3" dark flat>
        <v-btn
          v-permission="'application-tokens-create'"
          :to="{ name: 'application-tokens-create' }"
          color="primary"
          class="elevation-0"
        >
          Создать
        </v-btn>
      </v-toolbar>
      <v-data-table
        :items="list"
        :loading="isLoading"
        :headers="headers"
        :items-per-page="15"
        item-key="id"
        hide-default-footer
      >
        <template #item.createdAt="{ item }">
          {{ formattedCreatedAt(item) }}
        </template>

        <template #item.actions="{ item }">
          <v-btn
            v-permission="['application-tokens-delete']"
            medium
            color="error"
            @click="$dialog.show('application-tokens-remove-confirmation', { itemId: item.id })"
          >
            <v-icon medium>delete</v-icon>
          </v-btn>
        </template>

        <template v-if="pagination" #footer>
          <v-pagination
            :length="pagination.lastPage"
            :total-visible="8"
            :value="pagination.currentPage"
            :disabled="pagination.lastPage === 1"
            color="blue darken-3"
            class="pb-4 pt-4"
            @next="onChangePage(pagination.currentPage + 1)"
            @previous="onChangePage(pagination.currentPage - 1)"
            @input="onChangePage($event)"
          />
        </template>
      </v-data-table>
    </v-card>

    <remove-confirmation
      name="application-tokens-remove-confirmation"
      title="Вы действительно желаете удалить токен приложения?"
      @confirmed="onRemove"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import RemoveConfirmation from '@/components/dialogs/confirmations/RemoveConfirmation.vue';
import moment from 'moment';

export default {
  name: 'application-tokens-list-view',
  asyncData({ store }) {
    return store.dispatch('applicationTokens/getList');
  },
  components: { RemoveConfirmation },
  data: () => ({
    isLoading: false,
    headers: [
      { value: 'id', text: 'ID', sortable: false },
      { value: 'name', text: 'Название', sortable: false },
      { value: 'token', text: 'Токен', sortable: false },
      { value: 'createdAt', text: 'Дата создания', sortable: false },
      {
        value: 'actions',
        sortable: false,
        width: '30%',
        align: 'right',
      },
    ],
  }),
  computed: {
    ...mapState('applicationTokens', ['list', 'pagination']),

    formattedCreatedAt() {
      return (item) => (item.createdAt ? moment(item.createdAt.date).format('DD.MM.YYYY HH:mm') : null);
    },
  },
  methods: {
    ...mapActions('applicationTokens', ['getList', 'getNextPage', 'remove']),
    ...mapActions(['showNotify']),

    async onChangePage(page) {
      this.isLoading = true;
      await this.getNextPage({ page });
      this.isLoading = false;
    },

    async onRemove(id) {
      this.isLoading = true;
      await this.remove(id)
        .then(async () => {
          this.showNotify({ message: 'Токен успешно удален' });
          await this.getList();
        })
        .catch(error => {
          this.showNotify({ type: 'error', message: 'Что-то пошло не так' });
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
